<style scoped lang="scss">
    .upload-file-container {
        border: thin #888 dashed;
        padding: 30px;
        background-color: #efefef;
        font-size: 1.1em;
    }

    .document-container {
        padding: 10px 25px;
        border: thin solid #999;
        margin-bottom: 20px;
        align-items: center;
        .icon-container {
            margin-right: 20px;
        }

        .document-title {
            font-size: 1.2em;
            margin-bottom: 2px;
        }
        .details {
            color: #666;
        }
    }
    .uk-card-primary {
        color: white;
        background-color: #0f7ae5;
        padding: 20px;
        font-size: 1.2em;
        border-radius: 6px;
        margin-left: 40px;
        margin-right: 40px;
    }

    .uk-button-inverse {
        color: white;
        background-color: #333;
    }
</style>

<template>
    <div class="uk-width-9-10 uk-align-center uk-grid">
        <h3 v-if="showCategory" class="uk-margin-remove uk-width-1-1">
            <i class="uk-icon-file"></i>
            {{ request.category.document_category_name }}
            <span style="font-size: 0.9em; color: #999;" v-if="request.household_member"> | {{ request.household_member.first_name }} {{ request.household_member.last_name }}</span>
            <span v-if="request.required" class="uk-text-danger uk-text-small">* Required</span>
            <div v-if="request.category.document_category_desc" class="uk-margin-bottom"><small v-html="request.category.document_category_desc"></small></div>
        </h3>
        <h4 style="font-size: 1.2em; font-weight: bold; font-style: italic;" class="uk-width-1-1 uk-margin-bottom uk-margin-top" v-if="isBackendLabel(request.details)">
          {{ getLangLabel(request.details) }}
        </h4>
        <h4 style="font-size: 1.2em; font-weight: bold; font-style: italic;" class="uk-width-1-1 uk-margin-bottom uk-margin-top" v-else>
          {{ request.details }}
        </h4>
        <div v-if="request.category.attestations && request.category.attestations.length > 0" class="uk-width-1-1 uk-grid">
            <div class="uk-margin-remove-left uk-width-1-1 uk-align-center uk-margin-bottom uk-card uk-card-primary">
                <p align="center" v-html="request.category.attestation_instructions"></p>
                <div v-for="attestation in request.category.attestations" class="uk-margin-bottom">
                    <a :href="attestation.url" target="_blank" class="uk-button uk-button-default uk-button-large uk-width-1-1">
                        <i class="a-download-2"></i>
                        {{ __('global.download') }} {{ attestation.name }}</a>
                </div>
            </div>

        </div>
        <div v-if="showFiles" class="uk-grid uk-width-1-1 uk-margin-remove" v-for="document in requestDocuments">
            <div class="uk-width-1-1 document-container uk-flex uk-flex-space-between">
                <div class="uk-flex uk-center">
                    <div class="icon-container uk-text-center">
                        <a href="javascript:;" @click="previewFile(document)">
                            <i class="uk-icon-medium a-file-search"></i><br>
                            <span style="font-size: 0.8em;">PREVIEW</span>
                        </a>
                    </div>
                    <div>
                        <div class="document-title">{{ document.filename }}</div>
                        <div class="details">
                            Uploaded {{ document.created_at | moment }}
                        </div>
                    </div>
                    <div class="document-delete uk-flex-1 uk-align-right" v-if="programSettings['tenant-can-delete-documents']">
                      <a href="javascript:;" @click="deleteFile(document)" class="uk-text-danger">Delete File</a>
                    </div>
                </div>

                <div class="uk-text-right" v-if="permissions.processor">
                    <div class="approval-status">
                        <div v-if="document.approved == 1">APPROVED</div>
                        <div v-if="document.notapproved == 1">NOT APPROVED</div>
                        <div v-if="(document.notapproved == null && document.approved == null) || (document.notapproved == 0 && document.approved == 0)">PENDING REVIEW</div>
                    </div>
                    <div class="comment" v-if="document.comment">
                        <i class="a-comment"></i>
                        {{ document.comment }}
                    </div>
                </div>


            </div>
        </div>
        <div class="uk-grid uk-margin-left" v-for="upload in uploads">
            <div class="uk-width-1-1">
                <span class="uk-align-left">{{ upload.file.name }}</span>
                <span class="uk-align-right">
                            <button class="uk-button uk-button-secondary" @click="cancelUpload(upload)">Cancel</button>
                        </span>
            </div>
            <div class="uk-width-1-1">
                <progress :value="upload.progress" class="uk-width-1-1" max="100"/>
            </div>
        </div>
        <div class="uk-width-1-1 uk-margin-remove">
            <input type="file" ref="file" @change="addPickedFile($event);" multiple style="display: none">
            <div class="upload-file-container uk-border-rounded" @click.prevent="$refs.file.click()" @dragover.prevent @drop.prevent="addFile($event, request)">
                <div v-html="__('tenant.docs_please_upload')"></div>
            </div>
        </div>
        <hr class="uk-width-1-1 uk-grid-divider">
        <preview-documents-modal ref="previewModal"></preview-documents-modal>
        <edit-documents-modal v-if="permissions.processor" ref="editModal" @statusUpdated="onDocumentStatusUpdated" @confirm="onEditConfirm"></edit-documents-modal>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import PreviewDocumentsModal from "../../../../dashboard/pages/Documents/PreviewDocumentModal";
    import EditDocumentsModal from "../../../../dashboard/pages/Documents/EditDocumentsModal";

    export default {
        name: "DocumentRequestCategoryUpload",
        components: {EditDocumentsModal, PreviewDocumentsModal},
        props: {
            request: {
                type: Object,
                required: true,
            },
            showCategory: {
                type: Boolean,
                default: true,
            },
            showFiles: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                uploads: [],
                incomeTypes: [
                  {
                    id: 'primary_monthly',
                    label: this.__('tenant.inc_other_type_primary_monthly'),
                    backend_label: 'Monthly Gross Wages (Primary Job)',
                  },
                  {
                    id: 'secondary_monthly',
                    label: this.__('tenant.inc_other_type_secondary_monthly'),
                    backend_label: 'Monthly Gross Wages (Second Job)',
                  },
                  {
                    id: 'tertiary_monthly',
                    label: this.__('tenant.inc_other_type_tertiary_monthly'),
                    backend_label: 'Monthly Gross Wages (Third Job)',
                  },
                  {
                    id: 'self_employment_monthly',
                    label: this.__('tenant.inc_other_type_self_employment_monthly'),
                    backend_label: 'Self Employment',
                  },
                  {
                    id: 'service_pay',
                    label: this.__('tenant.inc_other_type_service_pay'),
                    backend_label: 'Severance pay',
                  },
                  {
                    id: 'operation_business',
                    label: this.__('tenant.inc_other_operation_business'),
                    backend_label: 'Operation of a Business or Profession Net Income',
                  },
                  {
                    id: 'sales_consulting',
                    label: this.__('tenant.inc_other_sales_consulting'),
                  },
                  {
                    id: 'worker-compensation',
                    label: this.__('tenant.inc_other_type_worker-compensation'),
                    backend_label: 'Worker’s compensation',
                  },
                  {
                    id: 'interest',
                    label: this.__('tenant.inc_other_type_interest'),
                    backend_label: 'Interest/dividends from assets, including bank accounts',
                  },
                  {
                    id: 'unemployment-benefit',
                    label: this.__('tenant.inc_other_type_unemployment-benefit'),
                    backend_label: 'Unemployment benefits',
                  },
                  {
                    id: 'ssi',
                    label: this.__('tenant.inc_other_type_ssi'),
                    backend_label: 'Social Security or Supplemental Security Income (SSI)',
                  },
                  {
                    id: 'annuities',
                    label: this.__('tenant.inc_other_type_annuities'),
                    backend_label: 'Annuities, pensions, and retirement funds (i.e. IRA, 401K)',
                  },
                  {
                    id: 'insurance',
                    label: this.__('tenant.inc_other_type_insurance'),
                    backend_label: 'Insurance policies, disability, death benefits, or similar types of periodic receipts',
                  },
                  {
                    id: 'alimony',
                    label: this.__('tenant.inc_other_type_alimony'),
                    backend_label: 'Alimony or child support',
                  },
                  {
                    id: 'regular_contribution',
                    label: this.__('tenant.inc_other_type_regular_contribution'),
                    backend_label: 'Regular contributions or gifts received from organizations or other persons not residing in the dwelling (including online donations such as GoFundMe or through a local bank)',
                  },
                  {
                    id: 'tanf',
                    label: this.__('tenant.inc_other_type_tanf'),
                    backend_label: 'Temporary Assistance for Needy Families (TANF)',
                  },
                  {
                    id: 'all_regular_pay',
                    label: this.__('tenant.inc_other_type_all_regular_pay'),
                    backend_label: 'All regular pay, special pay, and allowances of a member of the Armed Forces, except the special pay to a family member serving in the Armed Forces who is exposed to hostile fire (e.g., in the past, special pay included Operation Desert Storm)',
                  },
                  {
                    id: 'msa',
                    label: this.__('tenant.inc_other_msa'),
                    backend_label: 'MSA',
                  },
                  {
                    id: 'tribal_income',
                    label: this.__('tenant.inc_other_tribal_income'),
                    backend_label: 'Tribal Income',
                  },
                ],
            }
        },
        computed: {
            requestDocuments() {
                let docs = _.filter(this.documents, doc => {
                    return doc.household_application_document_request_id === this.request.id;
                })
                return docs;
            },
            uploadUrl() {
                return `/api/hope/application/${this.application.id}/documents`;
            },
            ...mapState('Application', {
                application: state => state.application,
                documentRequests: state => state.documentRequests,
                documents: state => state.documents,
                programSettings: state => state.application.program.settings,
            }),
            ...mapState('App', {
                permissions: state => state.permissions,
                env: state => state.env,
            })
        },
        methods: {
            addPickedFile($event) {
                _.each($event.target.files, file => {
                    file.status = 'uploading';
                    let upload = {
                        file,
                        progress: 0,
                        cancelToken: axios.CancelToken.source(),
                    };
                    this.uploads.push(upload)
                    this.uploadFile(upload);
                })
            },
            addFile($event) {
                _.each($event.dataTransfer.files, file => {
                    file.status = 'uploading';
                    let upload = {
                        file,
                        progress: 0,
                        cancelToken: axios.CancelToken.source(),
                    };
                    this.uploads.push(upload)
                    this.uploadFile(upload);
                })

            },
            async deleteFile(document) {
              let { isConfirmed, isDenied} = await this.$swal({
                title: this.__('tenant.inc_are_you_sure'),
                text: `Are you sure you would like to delete this file?`,
                icon: 'warning',
                showDenyButton: true,
                confirmButtonText: 'Yes, I Am Sure',
                denyButtonText: 'No, Cancel',
                imageClass: 'alert-image'
              })

              if(isConfirmed) {
                try {
                  let r = await axios.delete(`/api/hope/application/${this.application.id}/documents/${document.id}`);
                  this.$store.dispatch('Application/fetch', this.application.id);
                }catch(e) {
                  if(e.response.status === 403) {
                    this.$toast.error('You are not authorized to delete this file.');
                  }else {
                    this.$toast.error('An error has occurred.');
                  }
                }

              }
            },
            removeFile(upload) {
                let uploads = [];
                _.each(this.uploads, existing => {
                    if(existing.file.name !== upload.file.name) {
                        uploads.push(existing);
                    }
                })
                this.uploads = uploads;
            },
            uploadFile(upload) {
                let data = new FormData();
                data.append('file', upload.file);
                data.append('application_id', this.request.household_application_id);
                data.append('applicant_id', this.request.household_applicant_id);
                data.append('household_member_id', this.request.household_member_id);
                data.append('household_application_document_request_id', this.request.id);
                data.append('category_id', this.request.document_category_id)

                axios.post(this.uploadUrl, data, {
                    onUploadProgress: $event => this.onUploadProgress($event, upload),
                    cancelToken: upload.cancelToken.token,
                }).then(r => {
                    this.$store.dispatch('Application/addDocument', { document: r.data.document });
                    this.removeFile(upload);
                    this.$emit('uploaded', upload);
                }).catch(e => {

                })
            },
            cancelUpload(upload) {
                upload.cancelToken.cancel('');
                this.removeFile(upload);
            },
            onUploadProgress($event, upload) {

                let progress = 0;
                if($event.total > 0) {
                    progress = ($event.loaded / $event.total).toFixed(2) * 100;
                }
                upload.progress = progress;
                console.log($event, upload);
            },
            previewFile(document) {
                if(this.permissions.processor) {
                    let url =`/applicant/applications/${this.application.id}/documents/${document.id}/preview`;
                    this.$refs.editModal.open(url, document);
                }else {
                    let url =`/api/hope/application/${this.application.id}/documents/${document.id}/preview`;
                    this.$refs.previewModal.open(url, document);
                }

            },
            onEditConfirm($event) {
                // this.getData();
            },
            onDocumentStatusUpdated() {
                this.$store.dispatch('Application/fetch', this.application.id);
            },
            getDocumentCount() {
                return this.requestDocuments.length;
            },
            isBackendLabel(label) {
              return this.incomeTypes.some(obj => obj.backend_label === label);
            },
            getLangLabel(label) {
              const incomeItem = this.incomeTypes.find(obj => obj.backend_label === label);
              return incomeItem ? incomeItem.label : label;
            },
        }
    }
</script>
